import Vue from "vue";
export { Vue };
import App from "./app.vue";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GMAPS_API_KEY,
    libraries: "places"
  }
});
import "./styles/test.scss";
import "./styles/test.sass";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css"; // Only used for social media icons

import "@fortawesome/fontawesome-free/css/all.css"; // import "material-design-icons-iconfont/dist/material-design-icons.css";
// import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);
import Chartkick from "vue-chartkick";
import Chart from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
Chart.plugins.register(annotationPlugin);
Vue.use(Chartkick.use(Chart)); // TODO: make this opt-in

import VueYoutube from "vue-youtube";
Vue.use(VueYoutube); // import VueAnalytics from 'vue-analytics'
// // TODO: Avoid hardcoding
// Vue.use(VueAnalytics, {
//   id: 'UA-146876849-1'
// })

import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing, {
  networks: {
    copy: ""
  }
});
import "./extensions/string.js";
import "./extensions/array.js"; // Recursive components must be global

import VerticalPanel from "./components/panels/vertical";
import ResponsivePanel from "./components/panels/responsive";
import Component from "./components/component";
import CommonIcon from "./components/_icon";
import CommonBadge from "./components/_badge";
import CommonButton from "./components/_button";
import CommonChip from "./components/_chip";
import CommonMessage from "./components/_message";
import CommonDropdownMenu from "./components/_dropdownMenu";
import CommonResponsive from "./components/_responsive";
import CommonTemplateMenu from "./templates/_menu";
Vue.component("panels-vertical", VerticalPanel);
Vue.component("panels-responsive", ResponsivePanel);
Vue.component("common-button", CommonButton);
Vue.component("common-icon", CommonIcon);
Vue.component("common-badge", CommonBadge);
Vue.component("common-chip", CommonChip);
Vue.component("common-message", CommonMessage);
Vue.component("common-dropdownMenu", CommonDropdownMenu);
Vue.component("common-responsive", CommonResponsive);
Vue.component("templates-menu", CommonTemplateMenu);
Vue.component("glib-component", Component);
Vue.component("glib-icon", CommonIcon);
Vue.component("glib-panels-responsive", ResponsivePanel); // Vue.component("glib-templates-menu", CommonTemplateMenu);

import genericMixin from "./components/mixins/generic.js";
Vue.mixin(genericMixin);
import eventsMixin from "./components/mixins/events.js";
Vue.mixin(eventsMixin);
import stylesMixin from "./components/mixins/styles.js";
Vue.mixin(stylesMixin);
import scrollingMixin from "./components/mixins/scrolling.js";
Vue.mixin(scrollingMixin);
import datasetMixins from "./components/mixins/dataset.js";
Vue.mixin(datasetMixins);
Vue.prototype.extension = {};
import extension from "./components/mixins/extension.js";
Vue.mixin(extension);
import longClickDirective from "./components/mixins/longClick.js";
window.longClickInstance = longClickDirective({
  delay: 500,
  interval: 0
});
Vue.directive("longclick", window.longClickInstance); // TODO: Deprecate

import TypeUtils from "./utils/type";
Vue.use({
  install: function install(Vue, options) {
    Vue.prototype.$type = {
      isObject: TypeUtils.isObject,
      isString: TypeUtils.isString,
      isNumber: TypeUtils.isNumber,
      isArray: TypeUtils.isArray,
      ifObject: TypeUtils.ifObject,
      ifString: TypeUtils.ifString,
      ifNumber: TypeUtils.ifNumber,
      ifArray: TypeUtils.ifArray
    };
  }
});
import Utils from "./utils/helper";
window.Utils = Utils;
import Framework from "./utils/public";
window.GLib = Framework;
import { settings } from "./utils/settings";
export { settings };
import driverCustomBehavior from "./plugins/driverCustomBehavior";
Vue.use(driverCustomBehavior);
import updatableComponent from "./plugins/updatableComponent";
Vue.use(updatableComponent); // TODO: https://vuejs.org/v2/guide/components-dynamic-async.html#Async-Components
// Vue.component('async-webpack-example', function (resolve) {
//   // This special require syntax will instruct Webpack to
//   // automatically split your built code into bundles which
//   // are loaded over Ajax requests.
//   require(['./my-async-component'], resolve)
// })

import VueGtag from "vue-gtag";
document.addEventListener("DOMContentLoaded", function () {
  var gtagId = settings.gtagId;

  if (gtagId) {
    Vue.use(VueGtag, {
      config: {
        id: settings.gtagId,
        params: {
          send_page_view: false
        }
      }
    });
  }

  window.vueApp = {
    vuetify: new Vuetify({
      icons: {
        iconfont: "md"
      },
      theme: {
        themes: Utils.settings.themes
      },
      breakpoint: {
        smAndDown: true
      }
    }),
    page: window.__page,
    indicator: false,
    // Rename to isPageStale
    isStale: false,
    /// Dirty form handling
    isFormSubmitted: false,
    isFormDirty: false,
    ///
    stateUpdatedAt: null,
    webSocket: {
      channels: {},
      header: {}
    },
    actionCable: {
      channels: {}
    },
    temp: {}
  };
  new Vue({
    el: "#app",
    vuetify: window.vueApp.vuetify,
    data: {
      vueApp: window.vueApp
    },
    render: function render(createElement) {
      return createElement(App, {
        props: {
          page: this.$data.vueApp.page
        }
      });
    }
  });
}); // The above code uses Vue without the compiler, which means you cannot
// use Vue to target elements in your existing html templates. You would
// need to always use single file components.
// To be able to target elements in your existing html/erb templates,
// comment out the above code and uncomment the below
// Add <%= javascript_pack_tag 'hello_vue' %> to your layout
// Then add this markup to your html template:
//
// <div id='hello'>
//   {{message}}
//   <app></app>
// </div>
// import Vue from 'vue/dist/vue.esm'
// import App from '../app.vue'
//
// document.addEventListener('DOMContentLoaded', () => {
//   const app = new Vue({
//     el: '#hello',
//     data: {
//       message: "Can you say hello?"
//     },
//     components: { App }
//   })
// })